export class Image {
    public altText: string;
    public data: string;
    public src: string;
    public height: string;
    public width: string;
    public path: string;
}
